;"use strict";

!(function ($){

    $(window).on("load", function (){
        //setTimeout(function (){
            //if($(".product__info-wrapper .stamped-badge-caption").length) {
            $("body.template-product-gallery .stamped-badge-caption").before("<span data-r style='color: #000;'>" + $(".stamped-product-reviews-badge .stamped-badge")
                .attr("data-rating") + "/5</span>");
            //}
            //}, 1000);


        /*if($(".custom-pro-tag-section-wrapper .grid__item").length && $(window).width() > 750 && $('html[lang="en"]').length > 0){
            $(".custom-pro-tag-section-wrapper .grid__item").each(function (i, elem){
                $(elem).find(".value-price-wrapper").after("<div class='freeShipping' style='font-weight: bold;'>+ Free Shipping</div>")
            });
        }else{
            $(".custom-pro-tag-section-wrapper .grid__item").each(function (i, elem){
                $(elem).find(".value-price-wrapper").after("<div class='freeShipping' style='font-weight: bold;'>+ Free Shipping</div>")
            });
        }*/
    });

    let save_code = $("#discount_code__product");

    function copyToClipboard(element) {
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val($(element).text()).select();
        document.execCommand("copy");
        $temp.remove();
    }
    save_code.on("click", function (e){
        copyToClipboard(save_code);
    });


    if($("#color_name").length) {
        $("#color_name").text($("#color_name")
            .closest(".pro_variant__title").find("+ .VariantGroups .vpro-itme.active label").attr("data-color-name"));
    }


    /*document.addEventListener('DOMContentLoaded', () => {
        window.onscroll = function (e) {
            $("#js_affirm__price")
        };
    });*/

    $(".js_trigger__affirm").on("click", function (e){
        e.preventDefault();
        if($(this).closest(".price_wrap").find(".affirm-as-low-as .affirm-modal-trigger").length){
            $(this).closest(".price_wrap").find(".affirm-as-low-as .affirm-modal-trigger").trigger("click");
        }
    });


    /*if($(".slider_products").length){
        $(".slider_products").slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            speed: 1000,
            cssEase: 'linear',
            arrows: true,
            centerMode: true,

            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }*/


    var $carousel = $(".slider_products__grid");
    function showSliderScreen($widthScreen) {
        if ($widthScreen >= 768) {
            if (!$carousel.hasClass("slick-initialized")) {
                $carousel.slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    autoplay: false,
                    speed: 1000,
                    cssEase: 'linear',
                    arrows: true,
                    //centerMode: true,

                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
            }
        } else {
            if ($carousel.hasClass("slick-initialized")) {
                $carousel.slick("unslick");
            }
        }
    }

    var widthScreen = $(window).width();
    $(window).on("ready load resize", function () {
        widthScreen = $(window).width();
        setTimeout(function (){
            showSliderScreen(widthScreen);
        }, 100);
    });

$(window).on('load', function(){
    let _fl = true;
     setTimeout(function(){
      $("#launcher").parent('div').addClass("parent_launcher");
    }, 1000);

  jQuery(window).on("scroll", function (){
    if(_fl){
      setTimeout(function(){
        $("#launcher").parent('div').addClass("parent_launcher");
        _fl = false;
      }, 1000);
    }
  });
  });
})(jQuery);